module.exports = __webpack_public_path__ + "static/media/icon_chepai_n.ff6144ea.png";